export default {
  keys: {
    public: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
    secret: process.env.VUE_APP_STRIPE_SECRET_KEY,

    paymentAutomationPublic:
      process.env.VUE_APP_STRIPE_PAYMENT_AUTOMATION_PUBLIC_KEY,
    paymentAutomationSecret:
      process.env.VUE_APP_STRIPE_PAYMENT_AUTOMATION_SECRET_KEY
  }
};
